const useListColumns = () => {
  return [
    {
      Header: "Order",
      accessor: "order",
      disableGlobalFilter: true,
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Created at",
      accessor: "createDate",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._createDateTs - rowB.original._createDateTs,
    },
    {
      Header: "Updated at",
      accessor: "updateDate",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._updateDateTs - rowB.original._updateDateTs,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
